

import ClientHead from "@/components/main/core/ClientHead";
import GreyHeadBox from "@/components/main/core/GreyHeadBox";
import RedSection from "@/components/main/core/RedSection";
import BoxSection from "@/components/main/BoxSection";
import GreySection from "@/components/main/core/GreySection";
import BoxPhoto from "@/components/main/core/BoxPhoto";
import CheckBox from "@/components/main/core/CheckBox";
import MainButton from "@/components/main/buttons/MainButton";

import data from "@/mixins/data"

import dating from "assets/images/main/boxes/products/dating.png";
import social from "assets/images/main/boxes/products/social.png";
import locator from "assets/images/main/boxes/products/locator.png";
import tinder from "assets/images/main/boxes/products/tinder.png";
import xxx from "assets/images/main/boxes/products/xxx.png";
import cams from "assets/images/main/boxes/products/cams.png";




export default {
  name: "products",
  layout: 'clientLayout',
  head() {
    const title = 'Products & Services ᐈ iFindCheaters';
    const description = "A wide range of 【Online Products & Services】 to find and identify the cheating husband or wife ⏩ iFindCheaters!";

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
            }],
          }
        }
      ]
    };
  },

  mixins: [data],
  components: {ClientHead, GreyHeadBox, BoxSection, GreySection, BoxPhoto, RedSection, CheckBox, MainButton },
  data() {
    return {
      products: [
        {
          title: 'DATING/ALTERNATIVE LIFESTYLE SITES',
          mainText: 'The list of sites that our algorithms scan is growing constantly. Find out whether your partner has active profiles across a multitude of popular dating and alternative lifestyle platforms.',
          list1: 'Catch A Cheating Partner',
          list2: 'See If Partner Is Active Online',
          list3: 'Protect Yourself From Players',
          list4: 'Remove Doubt & Save Time',
          list5: 'Ensure Relationship Safety',
          list6: 'Eliminate Relationship Insecurity',
          img: dating,
          lnk: '/account/search-credits/',
          price: '$9.99',
          lnkRegister: '/auth/register?plan=5&product=DS'
        },
        {
          title: 'SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS',
          mainText: 'Find out if your partner is being honest about how they spend their free time. This service reveals active accounts on social media platforms with dating components as well as adult chat and booty-call apps.',
          list1: 'Catch A Cheating Partner',
          list2: 'See If Partner Is Active Online',
          list3: 'Protect Yourself From Players',
          list4: 'Remove Doubt & Save Time',
          list5: 'Ensure Relationship Safety',
          list6: 'Eliminate Relationship Insecurity',
          img: social,
          lnk: '/account/search-credits/',
          price: '$9.99',
          lnkRegister: '/auth/register?plan=5&product=SM'
        },
        {
          title: 'LISTING LOCATOR',
          mainText: 'You have a right to know if the person you are seeing is being honest about important information. With this service you can verify identity, addresses and phone numbers as well as marital and family status.',
          list1: 'Verify Personal Info & Family Status',
          list2: 'Catch A Cheating Partner',
          list3: 'ID Unknown Calls Or Texts',
          list4: 'Verify The Identity Of Someone New',
          list5: 'Protect Yourself From Scammers',
          list6: 'Feel Secure In Your Relationship',
          img: locator,
          lnk: '/account/listing-locator/',
          price: '$7.99',
          lnkRegister: '/auth/register?plan=8&product=LL'
        },
        {
          title: 'LIVE ADULT STREAMS',
          mainText: 'Find out whether your love interest subscribes to adult streams. Sex is an important part of a healthy relationship so it is important to know if your partner has interests you may not be comfortable with. Not to mention these streams can be pricey.',
          list1: 'Catch A Cheating Partner',
          list2: 'Learn What Turns Your Partner On',
          list3: 'Know More About Your Partner',
          list4: 'Stop Budget Leaks',
          list5: 'Save Your Relationship',
          list6: 'See If Partner Is Active Online',
          img: cams,
          lnk: '/account/search-credits/',
          price: '$14.99',
          lnkRegister: '/auth/register?plan=17&product=LC'
        },

        {
          title: 'XXX WEBSITES',
          mainText: 'Looking at porn does not automatically make someone a bad person but knowing what someone is into looking at can tell you a lot about them. Save yourself from potentially unpleasant surprises up front with this search tool.',
          list1: 'Catch A Cheating Partner',
          list2: 'Learn What Turns Your Partner On',
          list3: 'Know More About Your Partner',
          list4: 'Stop Budget Leaks',
          list5: 'Save Your Relationship',
          list6: 'See If Partner Is Active Online',
          img: xxx,
          lnk: '/account/search-credits/',
          price: '$14.99',
          lnkRegister: '/auth/register?plan=17&product=XS'
        },

        {
          title: 'TINDER BLASTER',
          mainText: 'Find out whether your partner is a swiper before they swipe your heart. This service offers different profile search options to help you discover whether your partner is using an active Tinder profile to meet others.',
          list1: 'Catch A Cheating Partner',
          list2: 'Discover Recent Activity',
          list3: 'Save Yourself From Heartbreak',
          list4: 'Learn More About Your Partner',
          list5: 'Feel Secure In Your Relationship',
          img: tinder,
          lnk: '/account/tinder-blaster-credits/',
          price: '$14.99',
          lnkRegister: '/auth/register?plan=2&product=TN'
        },

      ]
    }
  },
  computed: {
    isLogged() {
      return this.$store.state.userModule.isLogged
    },
  },
  mounted() {
  },
  methods: {}
}
